<!-- A page for internal development/debugging of overlay_options data.

It will try to visualize them as UI as it would appear for the end user
in the app.

-->
<template>
  <div style="max-width: 1220px">
    <v-layout
      v-if="showRefreshCheckbox"
      align-center
      class="mb-4"
    >
      <v-switch
        v-model="autoRefreshPeriodically"
        :label="$t('refreshAutomatically')"
        color="msr"
        class="ml-2 mt-0"
      />
    </v-layout>
    <overlay-data
      v-if="!!overlayOptions && !!overlayData"
      class="grow-1"
      validate-on-start
      :overlay-options="overlayOptions"
      :overlay-data="overlayData"
    />
  </div>
</template>

<script>
import OverlayData from '@/components/OverlayData';

import {getDefaultOverlayDataForOverlayOptions} from '@/mixins/overlayOptions.js';

export default {
  components: {
    OverlayData,
  },
  data() {
    return {
      overlayOptions: null,
      overlayData: null,
      autoRefreshPeriodically: false,
      hideDrawerIntervalId: null,
    };
  },
  computed: {
    /**
     * Hide the refresh checkbox when this page is embedded in an iframe.
     */
    showRefreshCheckbox() {
      return !this.$route.query.iframe;
    },
  },
  watch: {
    overlayOptions: {
      immediate: true,
      handler: function (overlayOptions) {
        if (!overlayOptions) {
          return;
        }
        this.overlayData =
          getDefaultOverlayDataForOverlayOptions(overlayOptions);
      },
    },
    autoRefreshPeriodically: function () {
      this.saveRefreshDecision();
    },
  },
  mounted() {
    this.loadRefreshDecision();

    this.hideDrawer();
    this.hideDrawerIntervalId = setInterval(() => {
      this.hideDrawer();
    }, 500);

    this.autoRefreshIntervalId = setInterval(() => {
      if (!this.showRefreshCheckbox || !this.autoRefreshPeriodically) {
        return;
      }
      this.getOverlayOptionsFromQueryParams();
    }, 3000);

    this.getOverlayOptionsFromQueryParams();
  },
  beforeDestroy() {
    if (this.hideToolbarDrawerHandler) {
      clearInterval(this.hideDrawerIntervalId);
    }
    if (this.autoRefreshIntervalId) {
      clearInterval(this.autoRefreshIntervalId);
    }
  },
  methods: {
    saveRefreshDecision() {
      window.sessionStorage.setItem(
        'overlayoptionsdev.autoRefreshPeriodically',
        this.autoRefreshPeriodically
      );
    },
    loadRefreshDecision() {
      this.autoRefreshPeriodically =
        window.sessionStorage.getItem(
          'overlayoptionsdev.autoRefreshPeriodically'
        ) == 'true';
    },
    getOverlayOptionsFromQueryParams() {
      if (!this.$route.query) {
        return;
      }

      const tvspotId = this.$route.query.tvspot;
      if (tvspotId) {
        this.$api.getTVSpotOverlayOptions(tvspotId).then((response) => {
          this.updateOverlayOptions(response.data);
        });
      }

      const tvtemplateId = this.$route.query.tvtemplate;
      if (tvtemplateId) {
        this.$api.getTVTemplateOverlayOptions(tvtemplateId).then((response) => {
          this.updateOverlayOptions(response.data);
        });
      }
    },
    updateOverlayOptions(newOverlayOptions) {
      if (
        this.overlayOptions != null &&
        JSON.stringify(this.overlayOptions) != JSON.stringify(newOverlayOptions)
      ) {
        console.log('[DEBUG]: Overlay Options have been refreshed');
      }
      this.overlayOptions = newOverlayOptions;
    },
    hideDrawer() {
      this.$store.commit('SET_SHOW_DRAWER', false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/OverlayOptionsDev.vue